import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlus, faMinus, faExpand, faSync } from '@fortawesome/free-solid-svg-icons';

import { publicUrlStr } from '../../utils';
import * as S from './style';

interface IImageViewer {
  imageSource?: string;
  onClose: () => void;
}


//Default: Plays 연구원 30주년 영상 on YT
//VideoSource: YT Video Key OR Video Name (ex: videoName.mp4)
function ImageViewer({ imageSource = 'default.jpg', onClose}: IImageViewer) {
  // Zoom scale
  const [scale, setScale] = useState(1);

  const containerRef = useRef<HTMLDivElement>(null);

  // Zoom In Handler: increase scale up to 10x
  const handleZoomIn = () => {
    setScale((prev) => Math.min(prev + 0.2, 10));
  };

  // Zoom Out Handler: decrease scale down to 1x minimum
  const handleZoomOut = () => {
    setScale((prev) => Math.max(prev - 0.2, 1));
  };

  // Reset Zoom Handler: reset scale to original 1x
  const handleResetZoom = () => {
    setScale(1);
  };

  // Fullscreen Handler
  const handleToggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen();
    } else {
      //exit fullscreen
      document.exitFullscreen();
    }
  };


  const imagePath =  `${publicUrlStr()}/images/${imageSource}`; //NO url() required!!!

  return (
    <S.Overlay 
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <S.ModalContainer onClick={(e) => e.stopPropagation()} ref={containerRef}>
        <S.CloseButton onClick={onClose}>
          <FontAwesomeIcon icon={faClose} aria-label="close" />
        </S.CloseButton>

        {/* Control Bar */}
        <S.ControlBar>
          <S.ControlButton onClick={handleZoomOut}>
            <FontAwesomeIcon icon={faMinus} />
          </S.ControlButton>
          <S.ControlButton onClick={handleZoomIn}>
            <FontAwesomeIcon icon={faPlus} />
          </S.ControlButton>
          <S.ControlButton onClick={handleResetZoom}>
            <FontAwesomeIcon icon={faSync} />
          </S.ControlButton>
          <S.ControlButton onClick={handleToggleFullscreen}>
            <FontAwesomeIcon icon={faExpand} />
          </S.ControlButton>
        </S.ControlBar>

        {/*Pan(Draggable) Image Container*/}
        <S.ImageContainer style={{ transform: `scale(${scale})` }}>
          <img 
            src={imagePath} 
            alt="Modal Content" 
            style={{ width: '100%', height: 'auto', pointerEvents: 'none' }}
          />
        </S.ImageContainer>
      </S.ModalContainer>
    </S.Overlay>
  );
}

export default ImageViewer;